import { newBrands } from '@/support/Brands';
import { Question } from '@/views/Users/Users';

 /**
   * Question
   *
   * DON'T EDIT OR CHANGE THE CURRENT QUESTION "TYPE" & "KEY"
   * THIS WILL HAVE IMPACT ON THE CURRENT STYLE QUIZ ANSWERS
   *
   *
   * IF YOU MAKE CHANGES, DO THIS:
   * - Make sure the admin looks good, the answers are in the leads
   * - Make sure the images are downsized (else they load too long etc)
   * - Stylists won't be able to see the old answers anymore in the admin. I'ts as if all old users filled in this quiz.
   *
*/

export const Questions: Question[] = [
  {
    type: 'start-form',
    category: 'stijl',
    title: 'Wat leuk dat we gaan beginnen!',
    questionText: 'Vul hieronder jouw naam en email adres in:',
    key: 'start-form_1',
  }, {
    type: 'preference',
    category: 'stijl',
    title: 'Stijl 1:',
    questionText: 'We willen jouw persoonlijke stijl graag beter begrijpen. Wat vind je bijvoorbeeld van deze stijl?',
    image: require('@/assets/images/stijl/classic/stijlen-classic.png'),
    key: 'preference_1',
    count: '1/5',
  }, {
    type: 'preference',
    category: 'stijl',
    title: 'Stijl 2:',
    questionText: 'We willen jouw persoonlijke stijl graag beter begrijpen. Wat vind je bijvoorbeeld van deze stijl?',
    image: require('@/assets/images/stijl/bohemian/stijlen-bohemian.png'),
    key: 'preference_2',
    count: '2/5',
  }, {
    type: 'preference',
    category: 'stijl',
    title: 'Stijl 3:',
    questionText: 'We willen jouw persoonlijke stijl graag beter begrijpen. Wat vind je bijvoorbeeld van deze stijl?',
    image: require('@/assets/images/stijl/sporty/stijlen-sporty.png'),
    key: 'preference_3',
    count: '3/5',
  }, {
    type: 'preference',
    category: 'stijl',
    title: 'Stijl 4:',
    questionText: 'We willen jouw persoonlijke stijl graag beter begrijpen. Wat vind je bijvoorbeeld van deze stijl?',
    image: require('@/assets/images/stijl/minimalistic/stijlen-minimalistic.png'),
    key: 'preference_4',
    count: '4/5',
  }, {
    type: 'preference',
    category: 'stijl',
    title: 'Stijl 5:',
    questionText: 'We willen jouw persoonlijke stijl graag beter begrijpen. Wat vind je bijvoorbeeld van deze stijl?',
    image: require('@/assets/images/stijl/romantic/stijlen-romantic.png'),
    key: 'preference_5',
    count: '5/5',
  },
  {
  type: 'boolean',
  category: 'stijl',
  title: 'Looks',
  questionText: 'Welke looks zou jij sowieso dragen?',
  image: require('@/assets/images/looks/look1.png'),
  key: 'looks_1',
  count: '1/16',
}, {
  type: 'boolean',
  category: 'stijl',
  title: 'Looks',
  questionText: 'Welke looks zou jij sowieso dragen?',
  image: require('@/assets/images/looks/look2.png'),
  key: 'looks_2',
  count: '2/16',
}, {
  type: 'boolean',
  category: 'stijl',
  title: 'Looks',
  questionText: 'Welke looks zou jij sowieso dragen?',
  image: require('@/assets/images/looks/look3.png'),
  key: 'looks_3',
  count: '3/16',
}, {
  type: 'boolean',
  category: 'stijl',
  title: 'Looks',
  questionText: 'Welke looks zou jij sowieso dragen?',
  image: require('@/assets/images/looks/look4.png'),
  key: 'looks_4',
  count: '4/16',
}, {
  type: 'boolean',
  category: 'stijl',
  title: 'Looks',
  questionText: 'Welke looks zou jij sowieso dragen?',
  image: require('@/assets/images/looks/look5.png'),
  key: 'looks_5',
  count: '5/16',
}, {
  type: 'boolean',
  category: 'stijl',
  title: 'Looks',
  questionText: 'Welke looks zou jij sowieso dragen?',
  image: require('@/assets/images/looks/look6.png'),
  key: 'looks_6',
  count: '6/16',
}, {
  type: 'boolean',
  category: 'stijl',
  title: 'Looks',
  questionText: 'Welke looks zou jij sowieso dragen?',
  image: require('@/assets/images/looks/look7.png'),
  key: 'looks_7',
  count: '7/16',
}, {
  type: 'boolean',
  category: 'stijl',
  title: 'Looks',
  questionText: 'Welke looks zou jij sowieso dragen?',
  image: require('@/assets/images/looks/look8.png'),
  key: 'looks_8',
  count: '8/16',
}, {
  type: 'boolean',
  category: 'stijl',
  title: 'Looks',
  questionText: 'Welke looks zou jij sowieso dragen?',
  image: require('@/assets/images/looks/look9.png'),
  key: 'looks_9',
  count: '9/16',
}, {
  type: 'boolean',
  category: 'stijl',
  title: 'Looks ',
  questionText: 'Welke looks zou jij sowieso dragen?',
  image: require('@/assets/images/looks/look10.png'),
  key: 'looks_10',
  count: '10/16',
}, {
  type: 'boolean',
  category: 'stijl',
  title: 'Looks ',
  questionText: 'Welke looks zou jij sowieso dragen?',
  image: require('@/assets/images/looks/look11.png'),
  key: 'looks_11',
  count: '11/16',
}, {
  type: 'boolean',
  category: 'stijl',
  title: 'Looks ',
  questionText: 'Welke looks zou jij sowieso dragen?',
  image: require('@/assets/images/looks/look12.png'),
  key: 'looks_12',
  count: '12/16',
}, {
  type: 'boolean',
  category: 'stijl',
  title: 'Looks ',
  questionText: 'Welke looks zou jij sowieso dragen?',
  image: require('@/assets/images/looks/look13.png'),
  key: 'looks_13',
  count: '13/16',
}, {
  type: 'boolean',
  category: 'stijl',
  title: 'Looks ',
  questionText: 'Welke looks zou jij sowieso dragen?',
  image: require('@/assets/images/looks/look14.png'),
  key: 'looks_14',
  count: '14/16',
}, {
  type: 'boolean',
  category: 'stijl',
  title: 'Looks ',
  questionText: 'Welke looks zou jij sowieso dragen?',
  image: require('@/assets/images/looks/look15.png'),
  key: 'looks_15',
  count: '15/16',
},{
  type: 'boolean',
  category: 'stijl',
  title: 'Looks ',
  questionText: 'Welke looks zou jij sowieso dragen?',
  image: require('@/assets/images/looks/look16.png'),
  key: 'looks_16',
  count: '16/16',
},
{
  type: 'checkbox-list',
  category: 'stijl',
  title: 'Stijl',
  questionText: 'Welke 5 woorden passen het beste bij jou als je denkt aan kleding (ongeacht de gelegenheid)?',
  maxSelection: 5,
  showCount: true,
  checkboxes: [{
    label: 'Stoer',
    key: 'stoer',
  }, {
    label: 'Luxe',
    key: 'luxe'
  }, {
    label: 'Romantisch',
    key: 'romantisch'
  }, {
    label: 'Natuurlijk',
    key: 'natuurlijk'
  }, {
    label: 'Relaxed',
    key: 'relaxed'
  }, {
    label: 'Comfortabel',
    key: 'comfortabel'
  }, {
    label: 'Verleidelijk',
    key: 'verleidelijk'
  }, {
    label: 'Kleurrijk',
    key: 'kleurrijk'
  }, {
    label: 'Eigenzinnig',
    key: 'eigenzinnig'
  }, {
    label: 'Stijlvol',
    key: 'stijlvol'
  }, {
    label: 'Sportief',
    key: 'sportief'
  }, {
    label: 'Trendy',
    key: 'trendy'
  }, {
    label: 'Verzorgd',
    key: 'verzorgd'
  }, {
    label: 'Traditioneel',
    key: 'traditioneel'
  }, {
    label: 'Vrouwelijk',
    key: 'vrouwelijk'
  }, {
    label: 'Nonchalant',
    key: 'nonchalant'
  }, {
    label: 'Netjes',
    key: 'netjes'
  }, {
    label: 'Praktisch',
    key: 'praktisch'
  }, {
    label: 'Kwaliteit',
    key: 'kwaliteit'
  }, {
    label: 'Creatief',
    key: 'creatief'
  }],
  key: 'checkbox-list_1',
  },
  {
    type: 'checkbox-list-boxes',
    category: 'stijl',
    title: 'Working day',
    questionText: 'Wat is de dresscode voor jouw werk?',
    checkboxes: [{
      label: 'Formeel',
      key: 'formeel',
    }, {
      label: 'Business Casual',
      key: 'business_casual',
    }, {
      label: 'Casual',
      key: 'casual',
    }, {
      label: 'n.v.t.',
      key: 'nvt',
    }],
    key: 'checkbox-list-boxes_1',
  },
  {
    type: 'agree-disagree',
    category: 'stijl',
    title: 'Stijl statements',
    questionText: 'Mee eens of oneens?',
    pills: [
      {
        title: '1. Prijs is niet belangrijk voor me als ik iets zie dat ik erg leuk vind.',
        key: 'agree_disagree_price',
        radiobuttons: [{
          label: '1',
          key: 'price_1',
        }, {
          label: '2',
          key: 'price_2'
        }, {
          label: '3',
          key: 'price_3'
        }, {
          label: '4',
          key: 'price_4'
        }, {
          label: '5',
          key: 'price_5'
        }]
      },
      {
        title: '2. De stijl van een item is voor mij belangrijker dan de kwaliteit.',
        key: 'agree_disagree_style',
        radiobuttons: [{
          label: '1',
          key: 'style_1',
        },
        {
          label: '2',
          key: 'style_2'
        },
        {
          label: '3',
          key: 'style_3'
        },
        {
          label: '4',
          key: 'style_4'
        },
        {
          label: '5',
          key: 'style_5'
        }]
      }
    ],
    key: 'agree_disagree_1',
  }, {
    type: 'agree-disagree',
    category: 'stijl',
    title: 'Stijl statements',
    questionText: 'Mee eens of oneens?',
    pills: [
    //   {
    //   title: '3. Ik volg de trends van mode designers op de voet en dat zie je vaak terug in mijn outfits.',
    //   key: 'agree_disagree_trends',
    //   radiobuttons: [{
    //     label: '1',
    //     key: 'trends_1',
    //   }, {
    //     label: '2',
    //     key: 'trends_2'
    //   }, {
    //     label: '3',
    //     key: 'trends_3'
    //   }, {
    //     label: '4',
    //     key: 'trends_4'
    //   }, {
    //     label: '5',
    //     key: 'trends_5'
    //   },
    // ],
    // },
    {
      title: '3. Meestal sta ik uitgebreid voor de spiegel voordat ik de deur uit ga.',
      key: 'agree_disagree_mirror',
      radiobuttons: [{
        label: '1',
        key: 'mirror_1',
      }, {
        label: '2',
        key: 'mirror_2'
      }, {
        label: '3',
        key: 'mirror_3'
      }, {
        label: '4',
        key: 'mirror_4'
      }, {
        label: '5',
        key: 'mirror_5'
      },
    ]},
    {
      title: '4. Ik wil me onderscheiden met de kleding die ik draag.',
      key: 'agree_disagree_distinguish',
      radiobuttons: [{
        label: '1',
        key: 'distinguish_1',
      }, {
        label: '2',
        key: 'distinguish_2'
      }, {
        label: '3',
        key: 'distinguish_3'
      }, {
        label: '4',
        key: 'distinguish_4'
      }, {
        label: '5',
        key: 'distinguish_5'
      },
    ]},
  ],
    key: 'agree_disagree_2',
  }, {
    type: 'agree-disagree',
    category: 'stijl',
    title: 'Stijl statements',
    questionText: 'Mee eens of oneens?',
    pills: [{
      title: '5. Mijn garderobe is up-to-date met het huidige modebeeld.',
      key: 'agree_disagree_trendy',
      radiobuttons: [{
        label: '1',
        key: 'trendy_1',
      }, {
        label: '2',
        key: 'trendy_2'
      }, {
        label: '3',
        key: 'trendy_3'
      }, {
        label: '4',
        key: 'trendy_4'
      }, {
        label: '5',
        key: 'trendy_5'
      },
    ]}],
    key: 'agree_disagree_3',
  }, {
    type: 'agree-disagree',
    category: 'stijl',
    title: 'Stijl statements',
    questionText: 'Mee eens of oneens?',
    pills: [{
      title: 'Meestal sta ik uitgebreid voor de spiegel voordat ik de deur uit ga.',
      key: 'agree_disagree_mirror1',
      radiobuttons: [{
        label: '1',
        key: 'mirror1_1',
      }, {
        label: '2',
        key: 'mirror1_2'
      }, {
        label: '3',
        key: 'mirror1_3'
      }, {
        label: '4',
        key: 'mirror1_4'
      }, {
        label: '5',
        key: 'mirror1_5'
      }],
    }],
    key: 'agree_disagree_mirror1',
  },
  // {
  //   type: 'agree-disagree',
  //   category: 'stijl',
  //   title: 'Stijl statements',
  //   questionText: 'Mee eens of oneens?',
  //   pills: [{
  //     title: '7. Ik maak er werk van om er verzorgd uit te zien.',
  //     key: 'agree_disagree_catered',
  //     radiobuttons: [{
  //       label: '1',
  //       key: 'catered_1',
  //     }, {
  //       label: '2',
  //       key: 'catered_2'
  //     }, {
  //       label: '3',
  //       key: 'catered_3'
  //     }, {
  //       label: '4',
  //       key: 'catered_4'
  //     }, {
  //       label: '5',
  //       key: 'catered_5'
  //     },
  //   ],
  //   }, {
  //     title: '8. Ik koop vaak items die lijken op wat ik al in de kast heb hangen.',
  //     key: 'agree_disagree_sameitems',
  //     radiobuttons: [{
  //       label: '1',
  //       key: 'sameitems_1',
  //     }, {
  //       label: '2',
  //       key: 'sameitems_2'
  //     }, {
  //       label: '3',
  //       key: 'sameitems_3'
  //     }, {
  //       label: '4',
  //       key: 'sameitems_4'
  //     }, {
  //       label: '5',
  //       key: 'sameitems_5'
  //     },
  //   ]
  //   }],
  //   key: 'agree_disagree_4',
  // },
  // {
  //   type: 'agree-disagree',
  //   category: 'stijl',
  //   title: 'Stijl statements',
  //   questionText: 'Mee eens of oneens?',
  //   pills: [{
  //     title: '9. Ik houd me absoluut niet bezig met wat er in de mode is.',
  //     key: 'agree_disagree_fashion',
  //     radiobuttons: [{
  //       label: '1',
  //       key: 'fashion_1',
  //     }, {
  //       label: '2',
  //       key: 'fashion_2'
  //     }, {
  //       label: '3',
  //       key: 'fashion_3'
  //     }, {
  //       label: '4',
  //       key: 'fashion_4'
  //     }, {
  //       label: '5',
  //       key: 'fashion_5'
  //     },
  //   ],
  //   }, {
  //     title: '10. Met mijn outfit wil ik mijn persoonlijkheid laten zien.',
  //     key: 'agree_disagree_personality',
  //     radiobuttons: [{
  //       label: '1',
  //       key: 'personality_1',
  //     }, {
  //       label: '2',
  //       key: 'personality_2'
  //     }, {
  //       label: '3',
  //       key: 'personality_3'
  //     }, {
  //       label: '4',
  //       key: 'personality_4'
  //     }, {
  //       label: '5',
  //       key: 'personality_5'
  //     },
  //   ]
  //   }],
  //   key: 'agree_disagree_5',
  // },
  // {
  //   type: 'agree-disagree',
  //   category: 'stijl',
  //   title: 'Stijl statements',
  //   questionText: 'Mee eens of oneens?',
  //   pills: [{
  //     title: '11. Ik vind het leuk om te experimenteren met mijn outfits en looks.',
  //     key: 'agree_disagree_experiment',
  //     radiobuttons: [{
  //       label: '1',
  //       key: 'experiment_1',
  //     }, {
  //       label: '2',
  //       key: 'experiment_2'
  //     }, {
  //       label: '3',
  //       key: 'experiment_3'
  //     }, {
  //       label: '4',
  //       key: 'experiment_4'
  //     }, {
  //       label: '5',
  //       key: 'experiment_5'
  //     },
  //   ],
  //   }, {
  //     title: '12. Voor mij is het belangrijker dat mijn kleding bij mij past, dan dat het fashionable is.',
  //     key: 'agree_disagree_fashionable',
  //     radiobuttons: [{
  //       label: '1',
  //       key: 'fashionable_1',
  //     }, {
  //       label: '2',
  //       key: 'fashionable_2'
  //     }, {
  //       label: '3',
  //       key: 'fashionable_3'
  //     }, {
  //       label: '4',
  //       key: 'fashionable_4'
  //     }, {
  //       label: '5',
  //       key: 'fashionable_5'
  //     },
  //   ]
  //   }],
  //   key: 'agree_disagree_6',
  // },
  // {
  //   type: 'agree-disagree',
  //   category: 'stijl',
  //   title: 'Stijl statements',
  //   questionText: 'Mee eens of oneens?',
  //   pills: [{
  //     title: '13. Het merk kleding dat ik koop is erg belangrijk voor mij.',
  //     key: 'agree_disagree_brand',
  //     radiobuttons: [{
  //       label: '1',
  //       key: 'brand_1',
  //     }, {
  //       label: '2',
  //       key: 'brand_2'
  //     }, {
  //       label: '3',
  //       key: 'brand_3'
  //     }, {
  //       label: '4',
  //       key: 'brand_4'
  //     }, {
  //       label: '5',
  //       key: 'brand_5'
  //     },
  //   ],
  //   }, {
  //     title: '14. Ik ben eigenlijk helemaal niet zo bezig met mijn uiterlijk.',
  //     key: 'agree_disagree_exterior',
  //     radiobuttons: [{
  //       label: '1',
  //       key: 'exterior_1',
  //     }, {
  //       label: '2',
  //       key: 'exterior_2'
  //     }, {
  //       label: '3',
  //       key: 'exterior_3'
  //     }, {
  //       label: '4',
  //       key: 'exterior_4'
  //     }, {
  //       label: '5',
  //       key: 'exterior_5'
  //     },
  //   ]
  //   }],
  //   key: 'agree_disagree_7',
  // },
  // {
  //   type: 'agree-disagree',
  //   category: 'stijl',
  //   title: 'Stijl statements',
  //   questionText: 'Mee eens of oneens?',
  //   pills: [{
  //     title: '15. Ik vind het moeilijk om mooie kleding te kopen voor de prijs die ik wil betalen.',
  //     key: 'agree_disagree_pay',
  //     radiobuttons: [{
  //       label: '1',
  //       key: 'pay_1',
  //     }, {
  //       label: '2',
  //       key: 'pay_2'
  //     }, {
  //       label: '3',
  //       key: 'pay_3'
  //     }, {
  //       label: '4',
  //       key: 'pay_4'
  //     }, {
  //       label: '5',
  //       key: 'pay_5'
  //     },
  //   ],
  //   }, {
  //     title: '16. Waar je me ook tegenkomt, ik zorg er voor dat ik er netjes uit zie.',
  //     key: 'agree_disagree_impeccable',
  //     radiobuttons: [{
  //       label: '1',
  //       key: 'impeccable_1',
  //     }, {
  //       label: '2',
  //       key: 'impeccable_2'
  //     }, {
  //       label: '3',
  //       key: 'impeccable_3'
  //     }, {
  //       label: '4',
  //       key: 'impeccable_4'
  //     }, {
  //       label: '5',
  //       key: 'impeccable_5'
  //     },
  //   ]
  //   }],
  //   key: 'agree_disagree_8',
  // },
  // TODO:
  // {
  //   type: 'auto-complete',
  //   category: 'stijl',
  //   title: 'Merken',
  //   questionText: 'Welke merken draag jij vaak?',
  //   key: 'brands',
  // },

  {
    type: 'checkbox-list',
    category: 'stijl',
    title: 'Merken',
    questionText: 'Welke merken draag jij vaak?',
    checkboxes: newBrands,
    key: 'brands',
    },

  // TODO:
  // CATEGORY: FIGUUR
  {
    type: 'category-screen',
    category: 'figuur',
    title: 'Dank je wel! ',
    questionText: 'Pasvorm is natuurlijk erg belangrijk. Daarom volgen nu een paar vragen over je figuur.',
    next_category: 'Volgende: Figuur',
    key: 'category-screen_1',
    image: [require('@/assets/images/intermezzo/figuur.jpg')]
  }, {
    type: 'body-figure',
    category: 'figuur',
    title: 'Figuur',
    questionText: 'Welk figuur past bij jou?',
    key: 'body-figure_1',
  }, {
    type: 'input-rows',
    category: 'figuur',
    title: 'Maten',
    questionText: 'Wat zijn jouw maten?',
    inputs: [{
      label: 'Hoe lang ben jij?',
      key: 'height',
      type: 'cm',
    }],
    key: 'input-rows_1',
  }, {
    type: 'dropdown-rows',
    category: 'figuur',
    title: 'Welke maten draag jij meestal?',
    questionText: 'Onze maatvoering gaat op dit moment tot confectiemaat 42. We zijn hard bezig om te kijken of we in de toekomst ook grotere maten kunnen aanbieden!',
    inputs: [{
      label: 'Tops',
      placeholder: 'maat',
      key: 'tops',
      type: 'none',
      options: ['XS', 'S', 'M', 'L', 'XL'],
    }, {
      label: 'Cup maat',
      placeholder: 'cup maat',
      key: 'cup_size',
      type: 'none',
      options: ['A', 'B', 'C', 'D', 'E', 'F', 'G'],
    }, {
      label: 'Band maat',
      placeholder: 'band maat',
      key: 'band_size',
      type: 'none',
      options: ['70', '75', '80', '85', '90', '95'],
    }, {
      label: 'Jeans Taille',
      placeholder: 'taille',
      key: 'jeans_taille',
      type: 'none',
      options: ['24', '25', '26', '27', '28', '29', '30', '31', '32', '33'],
    }, {
      label: 'Jeans Lengte',
      placeholder: 'lengte',
      key: 'jeans_lengte',
      type: 'none',
      options: ['30', '32', '34', '36'],
    }, {
      label: 'Schoenmaat',
      placeholder: 'maat',
      key: 'schoenmaat',
      type: 'none',
      options: ['35', '35,5', '36', '36,5', '37', '37,5', '38', '38,5', '39', '39,5', '40', '40,5', '41', '41,5', '42', '42,5', '43', '43,5', '44', '44,5', '45'],
    }, {
      label: 'Confectiemaat bovenkleding',
      placeholder: 'maat',
      key: 'confectiemaat_boven',
      type: 'none',
      options: ['32', '34', '36', '38', '40', '42'],
    }, {
      label: 'Confectiemaat onderkleding',
      placeholder: 'maat',
      key: 'confectiemaat_onder',
      type: 'none',
      options: ['32', '34', '36', '38', '40', '42'],
    }],
    key: 'input-rows_2',
  },
  {
    type: 'radio-list-boxes',
    category: 'figuur',
    title: 'Stijl',
    questionText: 'Hoe passen broeken jou meestal in de taille?',
    radiobuttons: [{
      label: 'Goed bij mijn middel, maar te strak bij mijn heupen en benen.',
      key: 'middel',
    }, {
      label: 'Goed bij mijn heupen en benen, maar te los bij mijn middel.',
      key: 'heupen-benen'
    }, {
      label: 'Goed bij mijn heupen, benen en middel.',
      key: 'all'
    }],
    key: 'radio-list-boxes_1',
  }, {
    type: 'radio-list-pill',
    category: 'figuur',
    title: 'Accentueren of camoufleren',
    questionText: 'Wat wil je accentueren of camoufleren?',
    pills: [{
      title: 'Armen',
      radiobuttons: [{
        label: 'Camoufleren',
        key: 'armen_camoufleren',
      }, {
        label: 'Neutraal',
        key: 'armen_neutraal'
      }, {
        label: 'Accentueren',
        key: 'armen_accentueren'
      }],
    }, {
      title: 'Schouders',
      radiobuttons: [{
        label: 'Camoufleren',
        key: 'schouders_camoufleren',
      }, {
        label: 'Neutraal',
        key: 'schouders_neutraal'
      }, {
        label: 'Accentueren',
        key: 'schouders_accentueren'
      }]
    }, {
      title: 'Halslijn',
      radiobuttons: [{
        label: 'Camoufleren',
        key: 'halslijn_camoufleren',
      }, {
        label: 'Neutraal',
        key: 'halslijn_neutraal'
      }, {
        label: 'Accentueren',
        key: 'halslijn_accentueren'
      }]
    }],
    key: 'radio-list-pill_1',
    }, {
    type: 'radio-list-pill',
    category: 'figuur',
    title: 'Accentueren of camoufleren',
    questionText: 'Wat wil je accentueren of camoufleren?',
    pills: [{
      title: 'Taille',
      radiobuttons: [{
        label: 'Camoufleren',
        key: 'taille_camoufleren',
      }, {
        label: 'Neutraal',
        key: 'taille_neutraal'
      }, {
        label: 'Accentueren',
        key: 'taille_accentueren'
      }],
    }, {
      title: 'Buik',
      radiobuttons: [{
        label: 'Camoufleren',
        key: 'buik_camoufleren',
      }, {
        label: 'Neutraal',
        key: 'buik_neutraal'
      }, {
        label: 'Accentueren',
        key: 'buik_accentueren'
      }]
    }],
    key: 'radio-list-pill_2',
  }, {
    type: 'radio-list-pill',
    category: 'figuur',
    title: 'Accentueren of camoufleren',
    questionText: 'Wat wil je accentueren of camoufleren?',
    pills: [{
      title: 'Benen',
      radiobuttons: [{
        label: 'Camoufleren',
        key: 'benen_camoufleren',
      }, {
        label: 'Neutraal',
        key: 'benen_neutraal'
      }, {
        label: 'Accentueren',
        key: 'benen_accentueren'
      }],
    }, {
      title: 'Rug',
      radiobuttons: [{
        label: 'Camoufleren',
        key: 'rug_camoufleren',
      }, {
        label: 'Neutraal',
        key: 'rug_neutraal'
      }, {
        label: 'Accentueren',
        key: 'rug_accentueren'
      }]
    }],
    key: 'radio-list-pill_3',
  }, {
    type: 'checkbox-list',
    category: 'figuur',
    title: 'Pasvorm',
    questionText: 'Wat is jouw pasvorm voorkeur voor tops?',
    maxSelection: 5,
    checkboxes: [{
      label: 'Strak',
      key: 'strak',
    }, {
      label: 'Getailleerd maar niet te strak',
      key: 'getailleerd_niet_strak'
    }, {
      label: 'Aansluitend',
      key: 'aansluitend'
    }, {
      label: 'Los',
      key: 'los'
    }, {
      label: 'Oversized',
      key: 'oversized'
    }],
    key: 'checkbox-list_2',
    },
    // CATEGORY: VOORKEUR
    {
    type: 'category-screen',
    category: 'voorkeur',
    title: 'Bedankt voor het delen!',
    questionText: 'Nu horen we graag hoe jij je kleding het liefste draagt.',
    next_category: 'Volgende: Voorkeur',
    key: 'category-screen_2',
    image: [require('@/assets/images/intermezzo/voorkeur.jpg')]
  },
{
    type: 'preference-withlabels',
    category: 'voorkeur',
    title: 'Jeans',
    questionText: 'Welke type jeans past bij jou?',
    labelTop: 'Skinny',
    labelBottom: '',
    image: require('@/assets/images/jeans/skinny.png'),
    key: 'preference-withlabels_1',
    count: '1/5',
  }, {
    type: 'preference-withlabels',
    category: 'voorkeur',
    title: 'Jeans',
    questionText: 'Welke type jeans past bij jou?',
    labelTop: 'Slimfit',
    labelBottom: '',
    image: require('@/assets/images/jeans/slimfit.png'),
    key: 'preference-withlabels_3',
    count: '2/5',
  }, {
    type: 'preference-withlabels',
    category: 'voorkeur',
    title: 'Jeans',
    questionText: 'Welke type jeans past bij jou?',
    labelTop: 'Bootcut',
    labelBottom: '',
    image: require('@/assets/images/jeans/bootcut.png'),
    key: 'preference-withlabels_4',
    count: '3/5',
  }, {
    type: 'preference-withlabels',
    category: 'voorkeur',
    title: 'Jeans',
    questionText: 'Welke type jeans past bij jou?',
    labelTop: 'Flare',
    labelBottom: '',
    image: require('@/assets/images/jeans/flare.png'),
    key: 'preference-withlabels_6',
    count: '4/5',
   }, {
     type: 'preference-withlabels',
     category: 'voorkeur',
     title: 'Jeans',
     questionText: 'Welke type jeans past bij jou?',
     labelTop: 'Pantalon',
     labelBottom: '',
     image: require('@/assets/images/jeans/pantalon.png'),
     key: 'preference-withlabels_7',
     count: '5/5',
  }, {
    type: 'preference-withlabels',
    category: 'voorkeur',
    title: 'Jeans',
    questionText: "Welke 'rise' type jeans past bij jou?",
    labelTop: 'Low rise',
    labelBottom: "Valt zo'n 5cm onder je navel",
    image: require('@/assets/images/rise/rise_jeans_low.jpg'),
    key: 'preference-withlabels_8',
    count: '1/3',
  }, {
    type: 'preference-withlabels',
    category: 'voorkeur',
    title: 'Jeans',
    questionText: "Welke 'rise' type jeans past bij jou?",
    labelTop: 'Medium rise',
    labelBottom: 'Valt net onder je navel',
    image: require('@/assets/images/rise/rise_jeans_mid.jpg'),
    key: 'preference-withlabels_9',
    count: '2/3',
  }, {
    type: 'preference-withlabels',
    category: 'voorkeur',
    title: 'Jeans',
    questionText: "Welke 'rise' type jeans past bij jou?",
    labelTop: 'High rise',
    labelBottom: 'Valt op of boven je navel',
    image: require('@/assets/images/rise/rise_jeans_high.jpg'),
    key: 'preference-withlabels_10',
    count: '3/3',
  },
  {
  type: 'checkbox-list',
  category: 'voorkeur',
  title: 'Rokken/Jurken',
  questionText: 'Welke lengte rok/jurk past bij jou?',
  maxSelection: 5,
  checkboxes: [{
    label: 'Boven de knie',
    key: 'boven_knie',
  }, {
    label: 'Op de knie',
    key: 'op_knie'
  }, {
    label: 'Maxi',
    key: 'maxi'
  }, {
    label: 'Midi',
    key: 'midi'
  }, {
    label: 'Mini',
    key: 'mini'
  }, {
    label: 'Ik draag geen rokken',
    key: 'geen'
  }, {
    label: 'Ik draag geen jurken',
    key: 'geen_jurk'
  }],
  key: 'checkbox-list_3',
  },
  {
    type: 'preference-withlabels',
    category: 'voorkeur',
    title: 'Halslijn',
    questionText: 'Welke halslijn past bij jou?',
    labelTop: 'Blouse',
    image: require('@/assets/images/halslijn/tops-blouse.png'),
    key: 'preference-withlabels_halslijn1',
    count: '1/7',
  }, {
    type: 'preference-withlabels',
    category: 'voorkeur',
    title: 'Halslijn',
    questionText: 'Welke halslijn past bij jou?',
    labelTop: 'Boothals',
    image: require('@/assets/images/halslijn/tops-boothals.png'),
    key: 'preference-withlabels_halslijn2',
    count: '2/7',
  }, {
    type: 'preference-withlabels',
    category: 'voorkeur',
    title: 'Halslijn',
    questionText: 'Welke halslijn past bij jou?',
    labelTop: 'Colkraag',
    image: require('@/assets/images/halslijn/tops-col.png'),
    key: 'preference-withlabels_halslijn3',
    count: '3/7',
  }, {
    type: 'preference-withlabels',
    category: 'voorkeur',
    title: 'Halslijn',
    questionText: 'Welke halslijn past bij jou?',
    labelTop: 'Off-Shoulder',
    image: require('@/assets/images/halslijn/tops-offshoulder.png'),
    key: 'preference-withlabels_halslijn5',
    count: '4/7',
  }, {
    type: 'preference-withlabels',
    category: 'voorkeur',
    title: 'Halslijn',
    questionText: 'Welke halslijn past bij jou?',
    labelTop: 'Ronde Hals',
    image: require('@/assets/images/halslijn/tops-rondehals.png'),
    key: 'preference-withlabels_halslijn6',
    count: '5/7',
   }, {
     type: 'preference-withlabels',
     category: 'voorkeur',
     title: 'Halslijn',
     questionText: 'Welke halslijn past bij jou?',
     labelTop: 'Strikhals',
     image: require('@/assets/images/halslijn/tops-strikhals.png'),
     key: 'preference-withlabels_halslijn7',
     count: '6/7',
  }, {
    type: 'preference-withlabels',
    category: 'voorkeur',
    title: 'Halslijn',
    questionText: 'Welke halslijn past bij jou?',
    labelTop: 'V-Hals',
    image: require('@/assets/images/halslijn/tops-vhals.png'),
    key: 'preference-withlabels_halslijn8',
    count: '7/7',
   },
  {
  type: 'checkbox-list',
  category: 'voorkeur',
  title: 'Kleuren',
  questionText: 'Welke kleuren spreken jou aan?',
  maxSelection: 5,
  checkboxes: [{
    label: 'Felle kleuren',
    key: 'felle_kleuren',
  }, {
    label: 'Neutrale kleuren',
    key: 'neutrale_kleuren'
  }, {
    label: 'Pastel kleuren',
    key: 'pastel_kleuren'
  }, {
    label: 'Natuurtinten',
    key: 'natuurtinten'
  }, {
    label: 'Donkere kleuren',
    key: 'donkere_kleuren'
  }],
  key: 'checkbox-list_4',
  },
  {
  type: 'checkbox-list',
  category: 'voorkeur',
  title: 'Kleuren',
  questionText: 'Welke kleuren draag je <strong class="strong--underline">niet</strong>?',
  maxSelection: 14,
  checkboxes: [{
    label: 'Beige',
    key: 'beige',
  }, {
    label: 'Lichtblauw',
    key: 'lichtblauw'
  }, {
    label: 'Donkerblauw',
    key: 'donkerblauw'
  }, {
    label: 'Bordeauxrood',
    key: 'bordeauxrood'
  }, {
    label: 'Mintgroen',
    key: 'mintgroen'
  }, {
    label: 'Lila',
    key: 'lila'
  }, {
    label: 'Donkergroen',
    key: 'donkergroen'
  }, {
    label: 'Paars',
    key: 'paars'
  }, {
    label: 'Okergeel',
    key: 'okergeel'
  }, {
    label: 'Rood',
    key: 'rood'
  }, {
    label: 'Geel',
    key: 'geel'
  }, {
    label: 'Zwart',
    key: 'zwart'
  }, {
    label: 'Kobaltblauw',
    key: 'kobaltblauw'
  }, {
    label: 'Bruin',
    key: 'bruin'
  }, {
    label: 'Donkergrijs',
    key: 'grijs'
  }, {
    label: 'Oranje',
    key: 'oranje'
  }, {
    label: 'Olijfgroen',
    key: 'olijfgroen'
  }, {
    label: 'Lichtgrijs',
    key: 'lichtgrijs'
  }, {
    label: 'Fuchsia',
    key: 'fuchsia'
  }, {
    label: 'Lichtroze',
    key: 'lichtroze'
  }, {
    label: 'Koraalroze',
    key: 'koraalroze'
  }, {
    label: 'Wit',
    key: 'wit'
  }, {
    label: 'Niet van toepassing',
    key: 'nvt'
  }],
  key: 'checkbox-list_5',
  },
  {
  type: 'checkbox-list',
  category: 'voorkeur',
  title: 'Stoffen',
  questionText: 'Welke stoffen draag je <strong class="strong--underline">niet</strong>?',
  maxSelection: 5,
  checkboxes: [{
    label: 'Leer',
    key: 'leer',
  }, {
    label: 'Nep leer',
    key: 'nep_leer'
  }, {
    label: '100% Wol',
    key: 'wol'
  }, {
    label: '100% Polyester',
    key: 'polyester'
  }, {
    label: 'Lurex / Glitter',
    key: 'lurex_glitter'
  }, {
    label: 'Zijde',
    key: 'zijde'
  }, {
    label: 'Niet van toepassing',
    key: 'nvt'
  }],
  key: 'checkbox-list_6',
  },
  {
  type: 'checkbox-list',
  category: 'voorkeur',
  title: 'Prints',
  questionText: 'Welke prints draag je <strong class="strong--underline">niet</strong>?',
  maxSelection: 6,
  checkboxes: [{
    label: 'Dierenprints',
    key: 'panterprints',
  }, {
    label: 'Stippen',
    key: 'stippen'
  }, {
    label: 'All-Over prints',
    key: 'all_over_prints'
  }, {
    label: 'Bloemen',
    key: 'bloemen'
  }, {
    label: 'Strepen',
    key: 'strepen'
  }, {
    label: 'Teksten',
    key: 'teksten'
  }, {
    label: "Logo's",
    key: 'logos'
  }, {
    label: 'Ruit',
    key: 'ruit'
  }, {
    label: 'Niet van toepassing',
    key: 'nvt'
  }],
  key: 'checkbox-list_7',
  },
  {
    type: 'radio-list-boxes',
    category: 'voorkeur',
    title: 'Overig',
    questionText: 'Hoe omschrijf jij jouw stijl voor accessoires en sieraden?',
    radiobuttons: [{
      label: 'Voornamelijk klassiek',
      key: 'klassiek',
    }, {
      label: 'Voornamelijk statement',
      key: 'statement',
    }, {
      label: 'Een mix van beide',
      key: 'klassiek_statement',
    }],
    key: 'radio-list-boxes_2',
  },
  {
    type: 'radio-list-boxes',
    category: 'voorkeur',
    title: 'Overig',
    questionText: 'Welke kleur sieraden draag jij bij voorkeur?',
    radiobuttons: [{
      label: 'Voornamelijk goud kleuren',
      key: 'goud_kleuren',
    }, {
      label: 'Voornamelijk zilver kleuren',
      key: 'zilver_kleuren',
    }, {
      label: 'Een mix van beide',
      key: 'goud_zilver_kleuren',
    }],
    key: 'radio-list-boxes_22',
  },
  {
    type: 'radio-list-boxes',
    category: 'voorkeur',
    title: 'Overig',
    questionText: 'Heb jij gaatjes in je oren?',
    radiobuttons: [
      {
        label: 'Ja',
        key: 'gaatjes_ja',
      },
      {
        label: 'Nee',
        key: 'gaatjes_nee',
      }
    ],
    key: 'radio-list-boxes_3',
  },
  {
    type: 'dropdown-rows',
    category: 'voorkeur',
    title: 'Meer over jou',
    toolTip: 'Bij ons beginnen tops vanaf ca. € 60 en broeken vanaf ca. € 90',
    questionText: 'Wat wil jij maximaal uitgeven aan jouw kleding?',
    inputs: [{
      label: 'Broeken',
      placeholder: 'euro',
      key: 'trousers',
      type: 'euro',
      alert: 'Let op: bij ons beginnen broeken vanaf ca. € 90',
      options: ['25-50', '50-75', '75-100', '75-100', '100-125', '125-150', '150-175', '175-200', '250-300', '300+'],
    }, {
      label: 'Jurkjes',
      placeholder: 'euro',
      key: 'dresses',
      type: 'euro',
      alert: 'Let op: bij ons beginnen jurkjes vanaf ca. € 90',
      options: ['25-50', '50-75', '75-100', '75-100', '100-125', '125-150', '150-175', '175-200', '250-300', '300+'],
    }, {
      label: 'Tops',
      placeholder: 'euro',
      key: 'tops',
      type: 'euro',
      alert: 'Let op: bij ons beginnen tops vanaf ca. € 60',
      options: ['25-50', '50-75', '75-100', '75-100', '100-125', '125-150', '150-175', '175-200', '250-300', '300+'],
    }, {
      label: 'Schoenen',
      placeholder: 'euro',
      key: 'shoes',
      type: 'euro',
      options: ['25-50', '50-75', '75-100', '75-100', '100-125', '125-150', '150-175', '175-200', '250-300', '300+'],
    }],
    key: 'input-rows_3',
  }, {
    type: 'dropdown-rows',
    category: 'voorkeur',
    title: 'Meer over jou',
    questionText: 'Wat geef jij per maand ongeveer uit aan kleding?',
    inputs: [{
      label: 'Per maand',
      placeholder: 'euro per maand',
      key: 'per_month',
      type: 'euro',
      options: ['25-75', '75-150', '150-250', '250-500', '500-750', '750-1500', '1500+'],
    }],
    key: 'input-rows_4',
  },
  {
    type: 'checkbox-list',
    category: 'voorkeur',
    title: 'Meer over jou',
    questionText: 'Waarom heb jij je aangemeld?',
    maxSelection: 6,
    checkboxes: [{
      label: 'Ik heb weinig tijd om zelf te shoppen',
      key: 'time',
    }, {
      label: 'Ik zoek iets voor een specifieke gelegenheid',
      key: 'event'
    }, {
      label: 'Ik weet niet hoe ik items moet combineren',
      key: 'combining'
    }, {
      label: 'Ik ben benieuwd naar hoe iemand anders mij zou kleden',
      key: 'others'
    }, {
      label: 'Ik ben op zoek naar nieuwe inspiratie',
      key: 'inspiration'
    }, {
      label: 'Ik wil mezelf verrassen met iets nieuws',
      key: 'suprise'
    }],
    key: 'checkbox-list_8',
  },
  {
    type: 'textarea',
    category: 'box',
    title: 'Box voorkeuren',
    questionText: 'Waar ben je op zoek naar in deze box?',
    checkboxes: [{
      label: 'Vooral zakelijk',
      key: 'business',
    },
    {
      label: 'Vooral casual',
      key: 'casual',
    },
    {
      label: 'Een mix tussen zakelijk en casual',
      key: 'business_casual',
    },
    // {
    //   label: 'Een box met een kerstset',
    //   key: 'christmas_set',
    // },
    {
      label: 'Voor een specifieke gelegenheid',
      key: 'specific_event',
    },
    // {
    //   label: 'Voor een specifieke gelegenheid',
    //   key: 'specific_event',
    // },
    // {
    //   label: 'Najaars items',
    //   key: 'summer_clothing',
    // },
    {
      label: 'Verras me maar!',
      key: 'suprise',
    }],
    key: 'radio-list-boxes_4',
  },
  {
    type: 'textarea',
    category: 'box',
    title: 'Box voorkeuren',
    questionText: 'Zijn er specifieke items die je graag zou willen ontvangen?',
    checkboxes: [{
      label: 'Leren jack',
      key: 'leren_jack',
    }, {
      label: 'Vest',
      key: 'vest'
    }, {
      label: 'Blazer',
      key: 'blazer'
    }, {
      label: 'Jurk',
      key: 'jurk'
    }, {
      label: 'Jeans',
      key: 'jeans'
    }, {
      label: 'Pantalon',
      key: 'pantalon'
    }, {
      label: 'Rok',
      key: 'rok'
    }, {
      label: 'Sweater',
      key: 'sweater'
    }, {
      label: 'Trui',
      key: 'trui'
    }, {
      label: 'Blouse',
      key: 'blouse'
    }, {
      label: 'Top',
      key: 'top'
    }, {
      label: 'T-shirt',
      key: 't-shirt'
    }, {
      label: 'Sieraden',
      key: 'sieraden'
    }, {
      label: 'Accessoires',
      key: 'accessoires'
    }, {
      label: 'Niet van toepassing',
      key: 'niet-van-toepassing'
    }],
    key: 'checkbox-list_wishlist',
  },
  {
    type: 'textarea',
    category: 'box',
    title: 'Box voorkeuren',
    questionText: 'Zijn er nog andere zaken waar we rekening mee moeten houden? Normaal gesproken sturen we 3 sets toe en in totaal ca. 15 items',
    key: 'textarea_1',
  },
  // CATEGORY: OVER_JOU
  {
    type: 'category-screen',
    category: 'over_jou',
    title: 'Helemaal super, je bent er bijna!',
    questionText: 'We willen alleen nog wat meer over jou weten.',
    next_category: 'Volgende: Over jou',
    key: 'category-screen_3',
    image: [require('@/assets/images/intermezzo/over_jou.jpg')]
  }, {
    type: 'personal-data-form',
    category: 'over_jou',
    title: 'Jouw persoonlijke gegevens',
    questionText: 'Naar dit adres versturen we ook jouw box.',
    key: 'personal-data-form_1',
  }, { // If you edit this question, also edit it in BlockImages.ts
    type: 'upload-file',
    category: 'over_jou',
    title: "Foto's",
    text: 'Zou jij een paar foto’s van jezelf kunnen uploaden zodat de styliste een beter beeld van je krijgt?',
    key: 'upload-file_1',
  },
  // CATEGORY: BOX
  // {
  //   type: 'category-screen',
  //   category: 'box',
  //   title: 'Top!',
  //   questionText: 'Als laatste willen we graag nog weten hoe je je box het liefst ontvangt.',
  //   next_category: 'Volgende: Jouw Box',
  //   key: 'category-screen_4',
  //   image: [require('@/assets/images/intermezzo/box.jpg')]
  // }, {
  //   type: 'shipping-data-form',
  //   category: 'box',
  //   title: 'Bezorgen',
  //   key: 'shipping-data-form_1',
  // },
  {
    type: 'reviews',
    category: 'box',
    title: 'DONE! Jouw stijl, wensen en voorkeuren zijn opgeslagen. Je bent er bijna!',
    key: 'review-question_1',
    reviews: [
      {
        name: 'Frances',
        description: 'Super leuk om vol verwachting op de maison365 box te wachten en vervolgens te ontdekken wat styliste Mandy allemaal heeft uitgekozen. Alleen al om die ervaring de moeite waard! Het liefst zou ik alles houden, maar er moeten toch keuzes gemaakt worden in het leven. 😉',
        image: require('@/assets/images/reviews/review1.png'),
      },
      {
        name: 'Kim',
        description: 'Heb al een paar keer een box ontvangen en vandaag komt de volgende. Weer fijn een nieuwe outfit na mijn bevalling!',
        image: require('@/assets/images/reviews/review2.png'),
      },
      {
        name: 'Jennifer',
        description: 'Superblij met al mijn boxen tot nu toe. Stukken gekocht waar ik zelf shoppend niet op zou zijn gekomen: zeker een keer doen!',
        image: require('@/assets/images/reviews/review3.png'),
      },
    ]
  },
  {
    type: 'referral-code-question',
    category: 'box',
    title: 'Heb je een kortingscode ontvangen?',
    questionText: '<br/>Vul deze kortingscode dan hier in om te activeren. De kortingscode zal dan worden toegepast op jouw kledingbox.',
    key: 'referral-code-question_1',
  },
  {
    type: 'final-question',
    category: 'box',
    title: 'Laat ons weten hoe je het beste bereikbaar bent en je hoort snel van ons!',
    key: 'final-question_1',
  },
  {
    type: 'order-question',
    category: 'order',
    title: 'Je bent er bijna!',
    key: 'order-question_1',
  },
  {
    type: 'check_order-question',
    category: 'check_order',
    title: 'Controleer jouw gegevens en bestelling hieronder.',
    key: 'check_order-question_1',
  },
  {
    type: 'payment-question',
    category: 'payment',
    title: 'Hoe wil jij betalen?',
    key: 'payment-question_1',
  }
];

// question types:
// - boolean
// - preference
// - preference-withlabels
// - checkbox-list
// - checkbox-list-boxes
// - radio-list-boxes
// - radio-list-pill
// - agree-disagree
// - upload-file
// - input-rows
// - dropdown-rows
// - body-figure
// - card-choices-blocks
// - personal-data-form
// - card-choices-row
// - final-question

// Categories
// - stijl
// - figuur
// - voorkeur
// - over_jou
// - box
